export default function getResource(label) {
    const resources = {
        onlyAFewLeft: 'ONLY A FEW LEFT'
    };
    return resources[label];
}
